/*
 * ATBT style studio (sections/atbt-style-studio.liquid)
 * Every panel is rendered server-side; this only switches which one is visible.
 * Works with several instances on a page and re-initialises inside the theme editor.
 */
(function () {
  'use strict';

  if (window.__atbtStyleStudioLoaded) return;
  window.__atbtStyleStudioLoaded = true;

  var ROOT = '[data-style-studio]';
  var TAB = '[data-style-tab]';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function tabsOf(root) {
    return toArray(root.querySelectorAll(TAB));
  }

  function panelFor(tab) {
    var id = tab.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function activate(root, tab, moveFocus) {
    if (!root || !tab) return;
    tabsOf(root).forEach(function (item) {
      var isActive = item === tab;
      item.classList.toggle('active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      var panel = panelFor(item);
      if (panel) panel.hidden = !isActive;
    });
    if (moveFocus) tab.focus();
  }

  function onKeydown(root, event) {
    var tab = event.target && event.target.closest ? event.target.closest(TAB) : null;
    if (!tab || !root.contains(tab)) return;

    var tabs = tabsOf(root);
    var index = tabs.indexOf(tab);
    var next = -1;

    switch (event.key) {
      case 'ArrowRight':
        next = (index + 1) % tabs.length;
        break;
      case 'ArrowLeft':
        next = (index - 1 + tabs.length) % tabs.length;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    activate(root, tabs[next], true);
  }

  function init(root) {
    // A JS property (not an attribute) marks bound roots, so markup that is
    // cloned or re-inserted via innerHTML still gets its listeners.
    if (!root || root.__atbtStyleStudioBound) return;
    root.__atbtStyleStudioBound = true;

    root.addEventListener('click', function (event) {
      var tab = event.target && event.target.closest ? event.target.closest(TAB) : null;
      if (!tab || !root.contains(tab)) return;
      activate(root, tab, false);
    });

    root.addEventListener('keydown', function (event) {
      onKeydown(root, event);
    });
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    if (context.matches && context.matches(ROOT)) init(context);
    toArray(context.querySelectorAll(ROOT)).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Theme editor support.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    var tab = target && target.closest ? target.closest(TAB) : null;
    if (!tab) return;
    var root = tab.closest(ROOT);
    if (!root) return;
    init(root);
    activate(root, tab, false);
  });
})();
